import React from 'react';
import IconBase from './IconBase';

const UserRemoveIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M16.8,10.8c-0.2,0-0.4-0.1-0.5-0.2C16.1,10.4,16,10.2,16,10s0.1-0.4,0.2-0.5c0.2-0.1,0.3-0.2,0.5-0.2h4
	c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H16.8z M9,11.7c-1,0-1.8-0.3-2.5-1
	c-0.7-0.7-1-1.5-1-2.5c0-1,0.3-1.8,1-2.5s1.5-1,2.5-1s1.8,0.3,2.5,1c0.7,0.7,1,1.5,1,2.5c0,1-0.3,1.8-1,2.5
	C10.8,11.4,10,11.7,9,11.7z M2.4,19.3c-0.2,0-0.5-0.1-0.6-0.2c-0.2-0.2-0.3-0.4-0.3-0.6v-1.3c0-0.5,0.1-0.9,0.4-1.4
	c0.3-0.4,0.6-0.7,1.1-1c1-0.5,2-0.8,3-1.1c1-0.2,2-0.4,3-0.4s2,0.1,3,0.4c1,0.2,2,0.6,3,1.1c0.4,0.2,0.8,0.6,1.1,1
	c0.3,0.4,0.4,0.9,0.4,1.3v1.3c0,0.3-0.1,0.5-0.3,0.6c-0.2,0.2-0.4,0.2-0.6,0.2H2.4z"/>
        </IconBase>
    )
}

export default UserRemoveIcon;